import React, { useMemo, useState } from 'react'
import { ReactComponent as Arrow } from './icons/arrow.svg'
import { useDetectClickOutside } from 'react-detect-click-outside'
import { getLevelName } from '../../../../../helpers/levels'
import BottomSheet from '../../../../BottomSheet'
import useDetectDevice from '../../../../../hooks/useDetectDevice'
import { captureEvent } from '../../../../../analytics'
import { analyticsEvents } from '../../../../../analytics/events'

function TVLevelPicker({ className = '', selectedLine, selectedLevel, onLevelSelected, ...props }) {
  const [toggled, setToggled] = useState(false)
  const ref = useDetectClickOutside({
    onTriggered: () => {
      setToggled(false)
    },
  })

  const levels = useMemo(() => {
    return selectedLine.unit_type_levels.map((l) => ({ id: l.id, data: l, label: getLevelName(l) }))
  }, [selectedLine])

  const { isMobile, isDesktop } = useDetectDevice()

  return (
    <div className={`${className}`} ref={ref}>
      <div
        role="button"
        className={`bg-white h-[64px] shadow rounded-[4px] flex items-center justify-center w-max`}
        onClick={() => {
          captureEvent(analyticsEvents.LEVEL_TAPPED)
          setToggled(!toggled)
        }}
      >
        <div className="px-[12px] text-[#3D4256] font-medium text-[22px] py-[7px] block">
          <>
            <span className="opacity-40">Floor</span>
            <span> #{selectedLevel.floor_number}</span>
          </>
        </div>
        <div
          className={`h-full cursor-pointer flex items-center justify-center border-l-[1px] border-solid border-[#BBBFCB] p-[9px]`}
        >
          <span className={`transition-all inline-block ${toggled ? 'rotate-[-180deg]' : ''}`}>
            <Arrow />
          </span>
        </div>
       
        {isDesktop && (
          <>
            {toggled && (
              <div className="w-full bg-[#fff] absolute bottom-[calc(64px+24px)]   mt-[12px] flex flex-col overflow-hidden rounded-[6px]">
                {levels
                  .filter((l) => l.id !== selectedLevel.id)
                  .map((level) => (
                    <button
                      type="button"
                      onClick={() => {
                        onLevelSelected(level)
                        setToggled(false)
                      }}
                      className="text-[22px] hover:bg-[#e4e4e4] text-left px-[16px] py-[10px] font-medium text-[#3D4256]"
                    >
                      {level.label}
                    </button>
                  ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default TVLevelPicker
